import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MaterialModule } from 'src/app/material.module';
import { ClinicalCategoryService } from '../clinicalCategory.service';
import { ToastrService } from 'ngx-toastr';
import { CategoryType, CategoryTypeLabels } from 'src/app/common/enums/category-type';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IClinicalCategory } from '../iclinical-category';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-hospital',
  standalone: true,
  imports: [
    MaterialModule,
    ReactiveFormsModule,
    CommonModule,
    MatInputModule,
    TranslateModule
  ],
  templateUrl: './clinicalcategory-detail.component.html',
})
export class ClinicalCategoryDetailsComponent implements OnInit {
  categoryForm: FormGroup;
  isEdit: boolean;
  public categoryTypeData = CategoryTypeLabels;
  public categoryTypeList = Object.values(CategoryType).filter(value => typeof value === 'number');

  constructor(
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private _data: { category: IClinicalCategory, isEdit: boolean, categoryValueFromItem: string },
    private _categoryService: ClinicalCategoryService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<ClinicalCategoryDetailsComponent>,
    private translate: TranslateService,
    private translationUtils: TranslationUtils
  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.categoryForm = this._formBuilder.group({
      name: [this._data?.category?.name || this._data?.categoryValueFromItem, [Validators.required, Validators.maxLength(100)]],
      categoryTypeId: [CategoryType[this._data?.category?.categoryTypeId ?? null], Validators.required],
      description: [this._data?.category?.description, [Validators.maxLength(255)]],
      seqno: [1]
    })

  }

  onCategorySave() {
    const category = this.categoryForm.getRawValue();
    this._categoryService.createCategory(category).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.CATEGORY')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });

  }

  onCategoryUpdate() {
    const category =
    {
      ...this.categoryForm.getRawValue(),
      id: this._data?.category?.id
    };
    this._categoryService.updateCategory(category).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          this.dialogRef.close(response);
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.CATEGORY')));
        }
      },
      error: (error) => {
        if (error?.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat();
          this.toastr.error(allErrors.join("\n"));
        } else {
          this.toastr.error('Something went wrong');
        }
      }
    });

  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}
